import axios from '@/api/api.js'
import {
  RUN_MULTIPLE_TEST_REPORTS,
  RUN_MULTIPLE_REGRESSION_REPORTS,
  RUN_DATABASE_LOG_REPORTS,
  RUN_LOG_REPORTS,
  RUN_PROTOCOL_REPORTS,
  RUN_SCHEDULE_REPORTS
} from '../endpoints/printModulesEndpoints'

export const postRequestForPdfReport = async (reportUrl, data) => {
  try {
    const response = await axios.post(reportUrl, data, {
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf'
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching PDF report: ', error)
    throw error
  }
}

export const runMultipleReportstest = async data =>
  postRequestForPdfReport(RUN_MULTIPLE_TEST_REPORTS, data)
export const runMultipleRegressionReport = async data =>
  postRequestForPdfReport(RUN_MULTIPLE_REGRESSION_REPORTS, data)
export const runStabilityDatabaseLogsReport = async data =>
  postRequestForPdfReport(RUN_DATABASE_LOG_REPORTS, data)
export const runStabilityLogsReport = async data => postRequestForPdfReport(RUN_LOG_REPORTS, data)
export const runReport = async data => postRequestForPdfReport(RUN_PROTOCOL_REPORTS, data)
export const runReportLMMV1 = async data => postRequestForPdfReport(RUN_SCHEDULE_REPORTS, data)
